module.exports = __webpack_public_path__ + "img/stancolas.d874eae7.jpg";